export default "__VITE_ASSET__Db64q26x__"